import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { SxProps } from '@mui/system';
import React from 'react';

import { ShareButton } from '@components/ShareButton';

import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { useIsMobile } from '@hooks/useIsMobile';
import { useSession } from '@hooks/useSession';

import { ShareType } from 'generated/types';

interface ShareCollectionButtonProps {
  share_type: ShareType;
  color?: string;
}

/**
 * Used to share a collection of records
 */
const ShareCollectionButton: React.FC<ShareCollectionButtonProps> = ({
  color,
  share_type,
}) => {
  const { flags } = useFeatureFlags();
  const {
    state: { activeProfile },
  } = useSession();

  const isMobile = useIsMobile();
  const theme = useTheme();

  const vitall_patient_id = activeProfile?.vitall_patient_id;

  const desktopStyle: SxProps = {
    color: color ?? 'primary.main',
    textAlign: 'right',
  };

  const mobileStyle: SxProps =
    share_type === ShareType.Timeline
      ? { ...desktopStyle }
      : {
          color: 'primary.contrastText',
          position: 'absolute',
          top: theme.spacing(2),
          right: theme.spacing(2),
        };

  const sxProps = isMobile ? mobileStyle : desktopStyle;

  if (!flags.isSharingCreateShareLinkEnabled) {
    return null;
  }

  return (
    <Box sx={sxProps}>
      {vitall_patient_id && (
        <ShareButton
          vitall_patient_id={vitall_patient_id}
          share_type={share_type}
          color={sxProps.color as string}
        />
      )}
    </Box>
  );
};

export default ShareCollectionButton;
